import { useEffect, useState } from "react";
import { MediaRecorder, register } from "extendable-media-recorder";
import { connect } from "extendable-media-recorder-wav-encoder";

export const  getquizid = window.location.pathname.split("/")[2];

const MIN_BLOB_SIZE = 500 * 1024;
var partSize = 0, parts = [];
var maxBlockSize = 768 * 1024;//Each file will be split in 256 KB.
var selectedFile = null;
var blockIds = [];
var blockIdPrefix = "block_";
var submitUri = null;
var Audiofilename = "";
const useRecorder = (audioChunks, audioUploadurl, Studentname, data_type, data_page_id, data_exercise_id, data_section_id, setAudioanalyzer) => {
  const [base64, setBase] = useState("");
  const [audioURL, setAudioURL] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState(null);
  const [isWavUsed, setIsWavUsed] = useState(false);
  if (data_type === "Assessment")
  {
    Audiofilename = `${Studentname}-${getquizid}-${data_section_id}${data_page_id}${data_exercise_id}.wav`;
  }
  else {
    Audiofilename = `${Studentname}-${getquizid}.wav`;
  }
  function handleFileSelect(file) {
    selectedFile = file;
    var fileSize = selectedFile.size;
    maxBlockSize = fileSize;
    var baseUrl = audioUploadurl 
    var indexOfQueryStart = baseUrl.indexOf("?");
    submitUri = baseUrl.substring(0, indexOfQueryStart) + '/' + selectedFile.name + baseUrl.substring(indexOfQueryStart);
  }

  var reader = new FileReader();
reader.onloadend = function (evt) {
    if (evt.target.readyState === FileReader.DONE) { // DONE == 2
        var uri = submitUri + '&comp=block&blockid=' + blockIds[blockIds.length - 1];
        var requestData = new Uint8Array(evt.target.result);
        const requestOptions = {
          method: 'PUT',
          headers: {
          "accept": "application/json",
          "Access-Control-Allow-Origin":"*",
          'x-ms-blob-type': 'BlockBlob',
          'Content-Length': requestData.length
        },
          body: requestData,
          processData: false,
          crossDomain: true,
        };
        fetch(uri, requestOptions)
        .then(response => console.log("chunkresponse",response))
    }
};
  function uploadFileInBlocks() {
        var fileContent = selectedFile.slice(0,maxBlockSize);
        var blockId = blockIdPrefix + pad(blockIds.length, 6);
        blockIds.push(btoa(blockId));
        reader.readAsArrayBuffer(fileContent);
  };
  function commitBlockList() {
    var uri = submitUri + '&comp=blocklist';
    var requestBody = '<?xml version="1.0" encoding="utf-8"?><BlockList>';
    for (var i = 0; i < blockIds.length; i++) {
        requestBody += '<Latest>' + blockIds[i] + '</Latest>';
    }
    requestBody += '</BlockList>';

    const requestOptions = {
      method: 'PUT',
      headers: {
      "accept": "application/json",
      "Access-Control-Allow-Origin":"*",
      'x-ms-blob-content-type': selectedFile.type},
      body: requestBody,
      crossDomain: true,
    };
    fetch(uri, requestOptions)
    .then( function(response){
       console.log("completed_upload",response)
       blockIds = [];
       setBase(response.url.split('?')[0]);
       setAudioURL(response.url.split('?')[0]);
    });
  
  };
  function pad(number, length){
    var str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
  }; 
  useEffect(() => {
    if (isWavUsed === false) {
      async function fetchMyAPI() {
        let response = await register(await connect());
        return response;
      }

      fetchMyAPI();
    }

    setIsWavUsed(true);
  }, [isWavUsed]);
  useEffect(() => {
    if (recorder === null) {
      if (isRecording) {
        requestRecorder(setAudioanalyzer).then(setRecorder, console.error);
      }
      return;
    }

    if (isRecording) {
      recorder.start(3000);
    } else {
      recorder.stop();
    }

    const handleData = (e) => {
      const blob_evt = e.data;
      partSize += blob_evt.size;
      parts.push(blob_evt);
      // var reader = new FileReader();
      // reader.readAsDataURL(e.data);
      // reader.onloadend = function () {
      //   var base64data = reader.result;
      //   console.log(base64data);
      // };
      if (partSize >= MIN_BLOB_SIZE) {
        const blob = new Blob(parts, {type: 'audio/wav'});
        const file = new File([blob], Audiofilename, {type: 'audio/wav'});
        handleFileSelect(file);
          partSize = 0;
          parts = [];
        setTimeout(() => {
          uploadFileInBlocks()
        },100);
      }
      audioChunks.push(blob_evt);
      // setAudioURL(URL.createObjectURL(e.data));
    };
    recorder.onstop = (e) => {
      if(audioURL !== "")
      {
        setAudioURL("");
      }
      const mainblob = new Blob(audioChunks, {type: 'audio/wav'});
      var reader = new FileReader();
      reader.readAsDataURL(mainblob);
      reader.onloadend = function () {
        var base64data = reader.result;
      };
      if(partSize > 0)
      {
        const blob = new Blob(parts, {type: 'audio/wav'});
        const file = new File([blob], Audiofilename, {type: 'audio/wav'});
        handleFileSelect(file);
        partSize = 0;
        parts = [];
        uploadFileInBlocks();
      }

      setTimeout(() => {
        commitBlockList();
      },500);
    };

    recorder.addEventListener("dataavailable", handleData);
    return () => recorder.removeEventListener("dataavailable", handleData);

  }, [recorder, isRecording]);

  const startRecording = () => {
    setIsRecording(true);
  };

  const stopRecording = () => {
    setIsRecording(false);
  };

  return [base64, audioURL, isRecording, startRecording, stopRecording,recorder];
};

async function requestRecorder(setAudioanalyzer) {
  // const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  // return new MediaRecorder(stream);
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  window.localstream =stream;
  const mediaRecoder = new MediaRecorder(stream, { mimeType: "audio/wav" });
  setAudioanalyzer(stream)
  return mediaRecoder;
}
export default useRecorder;
